class FilterTemplate {
    id: number;
    name: string;
    originalName: string;
    boundField: number;
    displayField: number;
    visibility: VisibilityEnum;
    dateRange: number;
    showBoundField: boolean;
    filterEditorType: FilterEditorTypeEnum;
    variable: string;
    originalVisibility: VisibilityEnum;
    order: number;

    get nodeId() { return this.id; }
    get nodeName() { return this.name; }

    get internalDisplayName() {
        return this.name;
    }

    constructor(data) {
        this.id = data.id;
        this.name = data.name;
        this.originalName = data.originalName;
        this.boundField = data.boundField;
        this.visibility = data.visibility;
        this.displayField = data.displayField;
        this.dateRange = data.dateRange;
        this.showBoundField = data.showBoundField;
        this.filterEditorType = data.filterEditorType;
        this.variable = data.variable;
        this.originalVisibility = data.originalVisibility;
        this.order = data.order;
    }
}